/* eslint-disable max-len */

import React from 'react';

export const Link = () => {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.37499 4.08301H4.08332C2.47249 4.08301 1.16666 5.38884 1.16666 6.99967C1.16666 8.61051 2.47249 9.91634 4.08332 9.91634H5.24999C6.86082 9.91634 8.16666 8.61051 8.16666 6.99967M9.62499 9.91634H9.91666C11.5275 9.91634 12.8333 8.61051 12.8333 6.99968C12.8333 5.38884 11.5275 4.08301 9.91666 4.08301H8.74999C7.13916 4.08301 5.83332 5.38884 5.83332 6.99967"
        stroke="#101828"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
